import React from 'react'
import { AppSvg, FormattedHTMLMessage, newIcons, TabBar, TabBarItem } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import cn from 'classnames'
import { lang } from '../lang'
import s from './s.module.css'
import { useCommonCMSConfig, useGetThreeDSChallengesData } from '~api'
import { Routes } from '~constants/routes'
import useSelectedTabs from '~hooks/useSelectedTabs'
import { globalLang } from '~globalLang'
import { useMenuStore } from '~store/menu'

// eslint-disable-next-line max-lines-per-function
function BottomTabBar() {
    const { showSwapPage, showStaking, hideMarketPage, showProTrade, showCards } =
        useCommonCMSConfig().data?.features ?? {}
    const tabs = useSelectedTabs()
    const intl = useIntl()
    const {
        data: { onCardClick },
    } = useMenuStore()

    const { data: chData } = useGetThreeDSChallengesData()

    return (
        <TabBar>
            <TabBarItem
                dataPointer="wallet"
                selected={tabs[Routes.wallet]}
                icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Home} />}
                to={Routes.wallet}
            >
                <FormattedHTMLMessage {...lang.wallet} />
            </TabBarItem>
            {!hideMarketPage && (
                <TabBarItem
                    dataPointer="market"
                    selected={tabs[Routes.market]}
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24SearchOutline} />}
                    to={Routes.market}
                >
                    <FormattedHTMLMessage {...lang.market} />
                </TabBarItem>
            )}
            {showCards && (
                <div className={s.cards} onClick={onCardClick}>
                    <TabBarItem
                        dataPointer="cards"
                        selected={tabs[Routes.cards]}
                        icon={
                            <div className="relative">
                                <AppSvg path="new-icons" size={24} svgName={newIcons.ic24Card} />
                                <div
                                    className={cn(
                                        'w-[8px] h-[8px] rounded-full bg-text-negative absolute top-[2px] right-0',
                                        chData?.challenges && chData?.challenges?.length > 0 ? 'block' : 'hidden'
                                    )}
                                />
                            </div>
                        }
                        to={Routes.cards}
                    >
                        <FormattedHTMLMessage {...lang.cards} />
                    </TabBarItem>
                </div>
            )}

            <TabBarItem
                dataPointer="history"
                selected={tabs[Routes.history]}
                icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24History} />}
                to={Routes.history}
            >
                <FormattedHTMLMessage {...lang.history} />
            </TabBarItem>
            {showSwapPage && (
                <TabBarItem
                    dataPointer="swap"
                    selected={tabs[Routes.swap]}
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Swap} />}
                    to={Routes.swap}
                >
                    <FormattedHTMLMessage {...lang.swap} />
                </TabBarItem>
            )}
            {showStaking && (
                <TabBarItem
                    dataPointer="staking"
                    selected={tabs[Routes.staking]}
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Percent} />}
                    to={Routes.staking}
                >
                    <FormattedHTMLMessage {...lang.staking} />
                </TabBarItem>
            )}
            {showProTrade && (
                <TabBarItem
                    dataPointer="exchange"
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Trading} />}
                    href={intl.formatMessage(globalLang.proLinkHref)}
                    openInCurrentWindow
                >
                    <FormattedHTMLMessage {...lang.exchange} />
                </TabBarItem>
            )}
        </TabBar>
    )
}

export default BottomTabBar
